module.exports = __webpack_public_path__ + "img/go_email.075726eb.png";